import type { Language, Marketplace, PLATFORMS } from '@amzn/journeys-common';
import { useSpyOnFieldValue } from 'hooks/form-spy/useSpyOnFieldValue';
import { useEffect } from 'react';
import { useForm } from 'react-final-form';
import { useFlavors } from '../../useFlavor';
import { useSchema } from '../../useSchema';
import { generateFlavorCreativeName } from '../../utils/generate-flavor-creative-name';

export function useUpdateFlavorNames(): void {
  const flavors = useFlavors();
  const formApi = useForm();

  const campaignName = useSpyOnFieldValue<string>({
    fieldPath: 'name',
  }) as string;
  const campaignSchema = useSchema();

  useEffect(() => {
    formApi.batch(() => {
      flavors.forEach((flavor, flavorIndex) => {
        if (flavor.active && flavor.hasGeneratedName) {
          const autoGeneratedName = generateFlavorCreativeName({
            campaignName,
            campaignSchema,
            language: flavor.scheduling.language as Language,
            marketplace: flavor.scheduling.marketplace as Marketplace,
            platform: flavor.scheduling.platform as PLATFORMS,
            variant: flavor.variant,
          });
          // biome-ignore lint/suspicious/noDoubleEquals: legacy code
          if (autoGeneratedName != flavor.creativeName) {
            formApi.change(`flavors[${flavorIndex}].creativeName`, autoGeneratedName);
          }
        }
      });
    });
  }, [
    campaignName,
    campaignSchema,
    flavors,
    formApi,
  ]);
}
